// ═══════════════════════════════════════════════════════════
// Claude API — routed through /api/claude (Pages Function)
// ═══════════════════════════════════════════════════════════

export interface ClaudeMessage {
  role: 'user' | 'assistant';
  content: string;
}

export async function callClaude(
  messages: ClaudeMessage[],
  opts?: { system?: string; maxTokens?: number },
): Promise<string> {
  const res = await fetch('/api/claude', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      model: 'claude-sonnet-4-20250514',
      max_tokens: opts?.maxTokens ?? 1024,
      system: opts?.system,
      messages,
    }),
  });
  if (!res.ok) throw new Error(`Claude API failed: ${res.status}`);
  const data = await res.json();
  return data.content?.[0]?.text ?? '';
}
